export const arrayToGroups = (list, howMany) => {
  const result = []
  const a = list.slice(0)
  while (a[0]) {
    result.push(a.splice(0, howMany))
  }
  return result
}
